<script lang="ts">
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import MediaPlayerComponent from 'src/components/MediaPlayerComponent.svelte';
	import ThermostatsG2 from 'src/components/DevicesSettings/Settings/SettingsG2/ThermostatsWallDisplay/ThermostatsG2.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import type { Device } from 'src/types/Device.ts';
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices_config } from '@devices/index';
	import {
		createGen1StatusLabels,
		getGen1DeviceStatuses,
	} from '../../SidePanelLayoutProvider/SidePanelDeviceLayout/Devices/Shelly/Gen1/gen1-main-helpers';
	import { real_id } from 'src/helpers/interface_helpers';
	import DeviceLabelList from '../DeviceLabelList.svelte';

	export let device: Device;

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	$: deviceConfig = devices_config?.[device?.type];
	$: _statuses = getGen1DeviceStatuses(status, device, settings, deviceConfig);
	$: labelList = createGen1StatusLabels(_statuses);
</script>

<DeviceViewStateWrapper {device}>
	<div slot="staticTop">
		<DeviceLabelList {labelList} />
		<DeviceNotificationLabel deviceId={device?.id} />
	</div>
	<!-- Wall Display with extracted peripheral (media player or thermostat) -->
	<div slot="content">
		{#if device?.category === 'thermostat'}
			<ThermostatsG2 {device} />
		{/if}
		{#if device?.category === 'media_player'}
			<MediaPlayerComponent {device} />
		{/if}
	</div>
</DeviceViewStateWrapper>
